"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var CreateConversion = /** @class */ (function () {
    function CreateConversion() {
        this.id = null;
        this.title = 'Conversion';
        this.locationName = null;
        this.startingUserName = null;
        this.inProducts = [];
        this.outProducts = [];
    }
    CreateConversion.prototype.fullPopulate = function (json) {
        Object.assign(this, json);
        this.inProducts = this.inProducts.map(function (p) { return Object.assign(new ConversionProduct(), p); });
        this.outProducts = this.outProducts.map(function (p) { return Object.assign(new ConversionProduct(), p); });
    };
    __decorate([
        mobx_1.observable
    ], CreateConversion.prototype, "id", void 0);
    __decorate([
        mobx_1.observable
    ], CreateConversion.prototype, "title", void 0);
    __decorate([
        mobx_1.observable
    ], CreateConversion.prototype, "locationId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateConversion.prototype, "locationName", void 0);
    __decorate([
        mobx_1.observable
    ], CreateConversion.prototype, "startingUserName", void 0);
    __decorate([
        mobx_1.observable
    ], CreateConversion.prototype, "variance", void 0);
    __decorate([
        mobx_1.observable
    ], CreateConversion.prototype, "notes", void 0);
    __decorate([
        mobx_1.observable
    ], CreateConversion.prototype, "status", void 0);
    __decorate([
        mobx_1.observable
    ], CreateConversion.prototype, "inProducts", void 0);
    __decorate([
        mobx_1.observable
    ], CreateConversion.prototype, "outProducts", void 0);
    __decorate([
        mobx_1.action
    ], CreateConversion.prototype, "fullPopulate", null);
    return CreateConversion;
}());
exports.CreateConversion = CreateConversion;
var ConversionProduct = /** @class */ (function () {
    function ConversionProduct() {
    }
    __decorate([
        mobx_1.observable
    ], ConversionProduct.prototype, "productId", void 0);
    __decorate([
        mobx_1.observable
    ], ConversionProduct.prototype, "productName", void 0);
    __decorate([
        mobx_1.observable
    ], ConversionProduct.prototype, "amount", void 0);
    __decorate([
        mobx_1.observable
    ], ConversionProduct.prototype, "productWeight", void 0);
    __decorate([
        mobx_1.observable
    ], ConversionProduct.prototype, "productUnit", void 0);
    __decorate([
        mobx_1.observable
    ], ConversionProduct.prototype, "weight", void 0);
    return ConversionProduct;
}());
exports.ConversionProduct = ConversionProduct;
//# sourceMappingURL=Conversion.js.map